import React, { useState, useCallback } from 'react';
import { BulkFlowStep } from './BulkFlowIndicator';
import BulkUploadWorkflow from './BulkUploadWorkflow';
import BulkReviewDetails from './BulkReviewDetails';
import { ReviewObjectDto } from '../../../services/bulkPricingReview/bulkPricingReview.types';

interface BulkUploadFlowProps {
  onFlowStateChange?: (currentStep: BulkFlowStep) => void;
}

const BulkUploadFlow: React.FC<BulkUploadFlowProps> = ({ onFlowStateChange }) => {
  const [currentStep, setCurrentStep] = useState<BulkFlowStep>('upload-review');
  const [selectedReview, setSelectedReview] = useState<ReviewObjectDto | null>(null);

  // Notify parent of state changes
  React.useEffect(() => {
    onFlowStateChange?.(currentStep);
  }, [currentStep, onFlowStateChange]);

  const handleReviewSelected = useCallback((review: ReviewObjectDto) => {
    setSelectedReview(review);
    setCurrentStep('review-details');
  }, []);

  const handleBackToList = useCallback(() => {
    setSelectedReview(null);
    setCurrentStep('upload-review');
  }, []);

  const handleUploadComplete = useCallback(() => {
    // After upload completes, stay on the same step (upload-review)
    // The list will refresh automatically and show the new job
  }, []);

  const handleActionCompleted = useCallback(() => {
    // After run/cancel action, go back to upload-review step
    setSelectedReview(null);
    setCurrentStep('upload-review');
  }, []);

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 'upload-review':
        return (
          <BulkUploadWorkflow
            onReviewSelected={handleReviewSelected}
            onUploadComplete={handleUploadComplete}
          />
        );

      case 'review-details':
        return selectedReview ? (
          <BulkReviewDetails
            review={selectedReview}
            onBack={handleBackToList}
            onActionCompleted={handleActionCompleted}
          />
        ) : null;

      default:
        return null;
    }
  };  return (
    <div>
      {renderCurrentStep()}
    </div>
  );
};

export default BulkUploadFlow;
